/**
 * @public
 */
export type DemoModeResponseBody = string;
